export enum PricingOptions {
    Head = 'Head',
    kg = 'kg',
    Unit = 'Unit',
    Bale = 'Bale',
    Tonne = 'Tonne',
}
